import * as thinkingAnimation from "../../Animations/chatbot-thinking.json"
import * as doneAnimation from "../../Animations/chatbot-happy.json"
import Lottie from 'react-lottie';

export function AILoader(){

    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: thinkingAnimation,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
  
    return <div className=" block-edit vanimation-fade-in no-delay w-full h-full center-all" style={{background:"#00000077",position:"fixed",top:0,left:0,zIndex:1000}}>
      <div className="vanimation-grow-in ai-load-container " ><Lottie options={defaultOptions} height={120} width={120} /></div>
      </div>
  
  
  }


  export function AILoaderFinish(){

    const defaultOptions = {
      loop: false,
      autoplay: true, 
      animationData: doneAnimation,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
  
    return <div className="w-full h-full center-all fade-out" style={{background:"#00000077",position:"fixed",top:0,left:0,zIndex:1000,pointerEvents:"none"}}>
      <div className="ai-load-container finished " ><Lottie  options={defaultOptions} height={120} width={120} /></div>
      </div>
  
  
  }
  